import { Component } from '@angular/core';

@Component({
  selector: 'app-supporter-view',
  templateUrl: './supporter-view.component.html',
  styleUrls: ['../shared/styles/path-selection.css']
})
export class SupporterViewComponent {

  constructor() { }

  canDeactivate() {
    return true;
  }
}
